import React, { MouseEvent } from 'react';
import { Price, PrimaryLabel, ProductImage } from '@noths/polaris-client-ribbons-design-system';
import { CurrencyCode } from '@noths/polaris-dev-ts-types';

import { RELATED_PREVIOUS_PRICE, RELATED_PRICE } from '.';
import { SimilarProduct } from 'src/types';
import * as styles from '../styles/PartnerStorefront.styles';

export interface PartnerProductCardProps {
  product: SimilarProduct;
  currency: CurrencyCode;
  onRelatedProductClick: (e: MouseEvent<HTMLAnchorElement>) => void;
}

export const PartnerProductCard = ({
  product,
  currency,
  onRelatedProductClick,
}: PartnerProductCardProps) => {
  const price = product.prices?.find((x) => x.currency === currency);
  const preSalePrice = product.pre_sale_prices?.find((x) => x.currency === currency);

  return (
    <div key={product.code} css={styles.relatedProductWrapper}>
      <h3 css={styles.productHeading}>
        <a
          href={product.links[0].href || ''}
          css={styles.imageLink}
          onClick={onRelatedProductClick}
        >
          <div css={styles.imageWrapper}>
            <ProductImage src={product.images[0].href} size="normal" css={styles.image} />
          </div>
          <p css={styles.productTitle}>{product.title}</p>
        </a>
      </h3>
      <PrimaryLabel
        className="similar-product-image__label"
        css={styles.productLabel}
        isNew={product.new}
        onSale={product.on_sale}
        hasStock={product.purchasable}
        salePercentage={product.sale_percentage}
      />
      <div>
        <Price
          testId={RELATED_PRICE}
          isSalePrice={!!(product.on_sale && preSalePrice)}
          css={styles.productPrice}
          amount={price!.amount}
          currency={currency}
        />
        {product.on_sale && preSalePrice && (
          <Price
            testId={RELATED_PREVIOUS_PRICE}
            isPreviousPrice={true}
            css={styles.productPreviousPrice}
            {...preSalePrice}
          />
        )}
      </div>
    </div>
  );
};
